import { render, staticRenderFns } from "./note-edit.html?vue&type=template&id=95e0b1ba&scoped=true&"
import script from "./note-edit.js?vue&type=script&lang=js&"
export * from "./note-edit.js?vue&type=script&lang=js&"
import style0 from "./note-edit.css?vue&type=style&index=0&id=95e0b1ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e0b1ba",
  null
  
)

export default component.exports